import { render, staticRenderFns } from "./solvency.vue?vue&type=template&id=dbb4c458&scoped=true&"
import script from "./solvency.vue?vue&type=script&lang=js&"
export * from "./solvency.vue?vue&type=script&lang=js&"
import style0 from "./solvency.vue?vue&type=style&index=0&id=dbb4c458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb4c458",
  null
  
)

export default component.exports